<template>
  <v-card v-if="message">
    <v-card-title class="mb-0 py-0 subtitle-2">{{ message.user.firstName + " " + message.user.lastName }}</v-card-title>
    <v-card-text class="pb-0 subtitle-2">
      {{ $moment(message.sentDate).format("ddd D MMM - HH:mm") }}
    </v-card-text>
    <v-card-text class="mt-n2">
      {{ message.text }}

      <!-- VIDEO -->
      <div
        v-if="
          message.messageattachmentSet.length > 0 && getAttachments(message.messageattachmentSet, 'VIDEO').length > 0
        "
        class="pa-2"
      >
        <div
          v-for="(video, videoIndex) in getAttachments(message.messageattachmentSet, 'VIDEO')"
          :key="'video-' + videoIndex"
        >
          <vue-plyr>
            <video v-if="video.file" controls crossorigin playsinline>
              <source size="500" :src="video.file" type="video/mp4" />
            </video>
            <cld-video
              v-else-if="video.remoteFile"
              cloud-name="jeff-fitness"
              :public-id="video.remoteFile"
              controls
              crossorigin
              playsinline
            >
              <cld-transformation video_codec="auto" width="500" crop="pad" />
            </cld-video>
          </vue-plyr>
        </div>
      </div>

      <!-- IMAGES -->
      <div
        v-if="
          message.messageattachmentSet.length > 0 && getAttachments(message.messageattachmentSet, 'IMAGE').length > 0
        "
        class="images-wrapper mt-n2"
      >
        <v-row>
          <v-col
            v-for="(image, imageIndex) in getImageGallery(message.messageattachmentSet)"
            :key="imageIndex"
            class="d-flex child-flex pb-0 justify-center"
            :cols="imageGalleryCols(message)"
          >
            <v-img :src="image" :lazy-src="image" contain class="rounded-lg image-size" />
          </v-col>
        </v-row>
      </div>

      <!-- AUDIO -->
      <div
        v-if="
          message.messageattachmentSet.length > 0 && getAttachments(message.messageattachmentSet, 'AUDIO').length > 0
        "
        class="audio-ply"
      >
        <div
          v-for="(audio, audioIndex) in getAttachments(message.messageattachmentSet, 'AUDIO')"
          :key="'audio-' + audioIndex"
        >
          <div class="ml-n4">
            <vue-plyr
              :options="{
                volume: 1,
                controls: [
                  'play-large',
                  'play',
                  'progress',
                  'current-time',
                  'captions',
                  'settings',
                  'pip',
                  'airplay',
                  'fullscreen',
                ],
              }"
            >
              <audio controls crossorigin playsinline>
                <source v-if="audio.file" :src="audio.file" type="audio/mp3" />
                <source v-else-if="audio.remoteFile" :src="cloudinaryAudioFile(audio.remoteFile)" type="audio/mp3" />
              </audio>
            </vue-plyr>
          </div>
        </div>
      </div>

      <!-- REACTIONS -->
      <div
        v-if="messageReactions(message) && messageReactions(message).length > 0"
        class="mx-2 reaction-bar right text-right"
      >
        <v-menu
          v-for="(messageReaction, index) in messageReactions(message)"
          :key="`message_${message.id}_reaction_${index}`"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar class="ml-1" color="#eee" size="40" v-bind="attrs" v-on="on">
              {{ messageReaction.reaction }}
              <span class="reaction-count">{{ messageReaction.users.length }}</span>
            </v-avatar>
          </template>
          <div class="pa-2 caption" style="background-color:white;">
            {{ getReactionUserList(messageReaction.users) }}
          </div>
        </v-menu>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ChatMixin from "@/components/shared/mixins/ChatMixin";

export default {
  name: "ChatMessageView",
  mixins: [ChatMixin],
};
</script>

<style lang="scss" scoped>
.reaction-count {
  font-weight: bold;
  font-size: 11px;
  margin-top: 3px;
  margin-left: 2px;
}
</style>
